export const WeddingKeys = {
  all: ['weddings'] as const,
  details: () => [...WeddingKeys.all, 'details'] as const,
  detail: (slug: string) => [...WeddingKeys.details(), slug] as const,
  mine: () => [...WeddingKeys.all, 'mine'] as const,
}
